import {
  ParagraphAccordion,
  ParagraphAccordionItem,
  ParagraphContentOverview,
  ParagraphCTA,
  ParagraphDownloads,
  ParagraphEventsFiltered,
  ParagraphEventsUpcoming,
  ParagraphFAQ,
  ParagraphHighlightedItem,
  ParagraphHighlightedSelection,
  ParagraphLinkList,
  ParagraphMetricItem,
  ParagraphMetrics,
  ParagraphQuote,
  ParagraphText,
  ParagraphTextImageGrid,
  ParagraphTextMedia,
  ParagraphUSP,
  ParagraphUSPSubparagraph,
  ParagraphVacanciesMap,
  ParagraphWebform,
} from '../implementations';

const mappers = {
  accordion_item: ParagraphAccordionItem,
  accordion: ParagraphAccordion,
  content_overview: ParagraphContentOverview,
  cta_wrapper: ParagraphCTA,
  cta: ParagraphCTA,
  downloads: ParagraphDownloads,
  events_filtered: ParagraphEventsFiltered,
  faq: ParagraphFAQ,
  highlighted_item: ParagraphHighlightedItem,
  highlighted_selection: ParagraphHighlightedSelection,
  link_list: ParagraphLinkList,
  metric_item: ParagraphMetricItem,
  metrics: ParagraphMetrics,
  quote: ParagraphQuote,
  text_image_grid: ParagraphTextImageGrid,
  text_media: ParagraphTextMedia,
  text: ParagraphText,
  upcoming_events: ParagraphEventsUpcoming,
  usp_subparagraph: ParagraphUSPSubparagraph,
  usp: ParagraphUSP,
  vacancies_map: ParagraphVacanciesMap,
  webform_wrapper: ParagraphWebform,
};

export default mappers;
